/* ic-ss v10 */
(function () {
  var BENEFITS = [
    'Save more with more frequent deliveries',
    'Fresh roasted coffee delivered automatically',
    'Choose delivery every 1, 2, 3, or 4 weeks',
    'Easily modify, skip, or cancel'
  ];

  function mainPI() { return document.querySelector('product-info[id^="MainProduct"]'); }

  /* ---- Eligibility data (Liquid-rendered per product; no hardcoded IDs) ---- */
  var eligCache;
  function elig() {
    if (eligCache !== undefined) return eligCache;
    var el = document.querySelector('script[data-ic-ss-eligibility]');
    eligCache = null;
    if (el) { try { eligCache = JSON.parse(el.textContent); } catch (e) {} }
    return eligCache;
  }
  function valueSubscribable(data, value) {
    for (var id in data.variants) {
      var v = data.variants[id];
      if (v.subscribable && v.options && v.options.indexOf(value) !== -1) return true;
    }
    return false;
  }
  function subscriptionSelected() {
    var r = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    return !!(r && r.value);
  }

  /* ---- Widget cosmetics: badge into the price row + benefits injection.
         Both run on EVERY scan and are idempotent no-ops once the DOM is
         already correct — the same continuously-enforced pattern as
         placeQty. Appstle re-renders (variant, frequency, or option
         changes) recreate the badge in its native spot beside the heading
         and can wipe the benefits list; the MutationObserver triggers a
         scan and both are restored within a frame. (An earlier ONE-SHOT
         guarded version of this badge move was the variant-switch bug: it
         could never re-apply after a re-render. The fix is continuous
         enforcement, not abandoning placement.) ---- */
  function enhanceWidget(w) {
    if (!w) return;
    var sub = w.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
    if (!sub) return;
    var badge = sub.querySelector('.appstle-save-badge');
    var amounts = sub.querySelector('.appstle_subscription_amount_wrapper');
    if (badge && amounts && (badge.parentNode !== amounts || amounts.lastElementChild !== badge)) amounts.appendChild(badge);
    if (!sub.querySelector('.ic-ss-benefits')) {
      var ul = document.createElement('ul');
      ul.className = 'ic-ss-benefits';
      for (var i = 0; i < BENEFITS.length; i++) {
        var li = document.createElement('li');
        li.textContent = BENEFITS[i];
        ul.appendChild(li);
      }
      var grid = sub.querySelector('.appstle_subscribe_option_grid');
      if (grid && grid.parentNode) { grid.parentNode.insertBefore(ul, grid); } else { sub.appendChild(ul); }
    }
  }

  /* ---- Zero-discount cleanup: when Appstle's own rendered state shows no
         savings for the selected plan (badge reads 0%, or regular and
         subscription prices are identical), hide the badge and the
         strikethrough. No plan IDs or percentages are hardcoded; the badge
         and prices remain Appstle's nodes and reappear untouched whenever
         the selected plan carries a real discount. Runs on every scan. ---- */
  function discountPass() {
    document.querySelectorAll('.appstle_sub_widget').forEach(function (w) {
      var sub = w.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');
      if (!sub) return;
      var badge = sub.querySelector('.appstle-save-badge');
      var amount = sub.querySelector('.appstle_subscription_amount');
      var compare = sub.querySelector('.appstle_subscription_compare_amount');
      var pct = null, badgeText = '';
      if (badge) {
        badgeText = (badge.textContent || '').replace(/ /g, ' ').trim();
        var m = badgeText.match(/(\d+(?:[.,]\d+)?)\s*%/);
        if (m) pct = parseFloat(m[1].replace(',', '.'));
      }
      function norm(el) { return el ? (el.textContent || '').replace(/\s+/g, '') : null; }
      var samePrice = !!(amount && compare && norm(amount) === norm(compare));
      var noDiscount = (pct === 0) || samePrice;
      /* An empty badge is Appstle's own zero-discount render: nothing to show,
         so the element leaves the layout entirely (its skin background/padding
         would otherwise paint as a bare gold pill). */
      var hideBadge = noDiscount || (badge && badgeText === '');
      /* Hide with the important flag: Appstle's stylesheet pins display with
         !important, which out-cascades a plain inline style. The [data-ic-hide]
         attribute lets the skin CSS enforce the same state declaratively. */
      if (badge) {
        if (hideBadge) {
          if (!badge.hasAttribute('data-ic-hide')) badge.setAttribute('data-ic-hide', '');
          badge.style.setProperty('display', 'none', 'important');
        } else {
          if (badge.hasAttribute('data-ic-hide')) badge.removeAttribute('data-ic-hide');
          badge.style.removeProperty('display');
        }
      }
      if (compare) {
        if (noDiscount) compare.style.setProperty('display', 'none', 'important');
        else compare.style.removeProperty('display');
      }
    });
  }

  /* ---- Quantity beside Add to Cart (native block relocated; input stays
         bound to the Shopify form via its form="" attribute) ---- */
  function placeQty(pi) {
    var btns = pi.querySelector('.f-product-single__block--buy_buttons .f-product-form__buttons');
    var qty = pi.querySelector('.f-product-single__block--quantity_selector');
    if (!btns || !qty) return;
    var submit = btns.querySelector('.f-product-form__submit');
    if (!submit) return;
    if (qty.parentNode !== btns) btns.insertBefore(qty, submit);
    btns.classList.add('ic-has-qty');
  }

  /* ---- Size gating: hide non-subscribable sizes while a selling plan is
         selected. Shopify stays the source of truth for the variant;
         Appstle stays the source of truth for plan eligibility. On products
         where every variant is subscribable, nothing is ever hidden. ---- */
  function applySizeGate(pi) {
    var data = elig();
    if (!data || !data.variants) return;
    var subMode = subscriptionSelected();
    var radios = pi.querySelectorAll('.variant-picker input[type="radio"]');
    if (!radios.length) return;
    radios.forEach(function (input) {
      var holder = input.closest('.variant-picker__option') || input.parentElement;
      if (!holder) return;
      var hide = subMode && !valueSubscribable(data, input.value);
      holder.style.display = hide ? 'none' : '';
    });
    if (!subMode) return;
    /* Auto-resolve: never leave an ineligible variant paired with a plan */
    var idInput = pi.querySelector('form[data-type="add-to-cart-form"] input[name="id"], form.main-product-form input[name="id"]');
    var cur = idInput && data.variants[idInput.value];
    if (cur && cur.subscribable) return;
    var target = null;
    for (var id in data.variants) {
      var v = data.variants[id];
      if (v.subscribable && v.available) { target = v; break; }
      if (v.subscribable && !target) target = v;
    }
    if (!target || !target.options) return;
    target.options.forEach(function (val) {
      radios.forEach(function (input) {
        if (input.value === val && !input.checked) input.click();
      });
    });
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    var pi = mainPI();
    document.querySelectorAll('.appstle_sub_widget').forEach(enhanceWidget);
    discountPass();
    if (pi) { placeQty(pi); applySizeGate(pi); }
  }
  function requestScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'selling_plan' || e.target.closest('.variant-picker') || e.target.closest('.appstle_sub_widget'))) requestScan();
  }, true);
  scan();
  new MutationObserver(requestScan).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();